import React from 'react'
import { CFooter } from '@coreui/react-pro'
import { COPYRIGHT_NAME } from 'src/utils/constant'
import { Link } from 'react-router-dom'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <Link to="#" target="_blank" rel="noopener noreferrer">
          {COPYRIGHT_NAME}
        </Link>
        <span className="ms-1">&copy; {(new Date()).getFullYear()}.</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
